/**
 * @desc 接收报告分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.inventoryReceiptPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/inventoryReceiptPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
